export const styles = () => ({
  wrap: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    boxSizing: 'border-box',
    background: 'rgba(0, 0, 0, 0.7)',
    zIndex: 999,
  },
  modal: {
    padding: 32,
    borderRadius: 10,
    background: '#fff',
    position: 'relative',
  },
  loader: {
    background: 'rgba(0, 0, 0, 0.4)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
})
